import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const ErpStockReportTableFilter = (props) => {
  const [form] = Form.useForm();

  const [productSelect, setProductSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setProductSelect({ ...productSelect, loading: true });
      RequestHandler.get(
        `/ErpReport/GetStockReport?$select=id,productName&$filter=${odata.contains(
          "productName",
          value
        )}`
      ).then((res) => {
        if (res[0].value) {
          setProductSelect({ data: res[0].value, loading: false });
        }
      });
    } else {
      setProductSelect({ ...productSelect, data: [] });
    }
  };

  const onFinish = (values) => {
    let query = "";
    const conditions = [];

    if (values.id) {
      conditions.push(`id eq ${values.id}`);
    }

    if (values.productCode) {
      conditions.push(odata.contains("productCode", values.productCode));
    }

    if (values.stockTypeValue || values.stockTypeValue === 0) {
      conditions.push(`stockTypeValue eq ${values.stockTypeValue}`);
    }

    if (values.mainGroupCode) {
      conditions.push(odata.contains("mainGroupCode", values.mainGroupCode));
    }

    if (values.subGroupCode) {
      conditions.push(odata.contains("subGroupCode", values.subGroupCode));
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    
    if (props.onFinishFilter) props.onFinishFilter(query);
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="firmFilter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label="Ürün Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      loading={productSelect.loading}
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {productSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.productName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="productCode" label="Ürün Kodu :">
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="stockTypeValue" label="Stok Türü :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {[
                        { id: 0, name: "Ticari Mal" },
                        { id: 1, name: "İlk Madde" },
                        { id: 2, name: "Ara Mamül" },
                        { id: 3, name: "Yarı Mamül" },
                        { id: 4, name: "Mamül" },
                        { id: 5, name: "Yan Mamül" },
                        { id: 6, name: "İşletme Malzemesi" },
                        { id: 7, name: "Tüketim Malzemesi" },
                        { id: 8, name: "Yedek Parça" },
                        { id: 9, name: "Akaryakıt Stok" },
                        { id: 10, name: "Montaj Reçeteli Mamül" },
                        { id: 11, name: "Temel Hammadde" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="mainGroupCode" label="Ana Grup :">
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="subGroupCode" label="Alt Grup :">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default ErpStockReportTableFilter;
